import { PaymentProviderState, REQUEST_PAYMENT_PROVIDER } from "./types";

const initialState: PaymentProviderState = {
  paymentProviders: []
};

export function paymentProvidersReducer(state = initialState, action: any) {
  switch (action.type) {
    case REQUEST_PAYMENT_PROVIDER:
      return action.payload;
    default:
      return state;
  }
}
